import React from 'react';

import { TCoursePreview } from '../../../types';
import { formatToSimpleDateTime, showToast } from '../../../helpers';
import ConfirmationPopup from '../ConfirmationPopup';
import { joinWaitlist } from '../../../requests';

interface IWaitlistConfirmationPopup {
  open: boolean;
  setOpen: (open: boolean) => void;
  coursePreview: TCoursePreview;
  sfLearnitCourseId?: string;
  onWaitlistJoined?: () => void;
}

const WaitlistConfirmationPopup: React.FC<IWaitlistConfirmationPopup> = ({
  open,
  setOpen,
  coursePreview,
  sfLearnitCourseId,
  onWaitlistJoined,
}) => {
  const handleJoinWaitlist = async () => {
    if (!sfLearnitCourseId) {
      showToast('Invalid course information', 'error');
      setOpen(false);
      return;
    }

    try {
      await joinWaitlist(sfLearnitCourseId);
      showToast(
        'You have been added to the waitlist. We will notify you when a spot becomes available.',
        'success',
        { duration: 12000 },
      );

      // Call the callback if provided
      if (onWaitlistJoined) {
        onWaitlistJoined();
      }
    } catch (error) {
      console.error(error);
      showToast(
        'Failed to join the waitlist. Please try again later.',
        'error',
        { duration: 12000 },
      );
    } finally {
      setOpen(false);
    }
  };

  return (
    <ConfirmationPopup
      title="Join Waitlist"
      open={open}
      setOpen={setOpen}
      cancelText="Cancel"
      confirmText="Join waitlist"
      onConfirm={handleJoinWaitlist}
    >
      <div className="flex flex-col gap-2 text-left">
        <div className="font-medium uppercase text-blue-primary">
          {coursePreview.nearestStartTime &&
            formatToSimpleDateTime(coursePreview.nearestStartTime)}
        </div>
        <div className="whitespace-normal text-heading-dark">
          {coursePreview.name}
        </div>
        <div className="font-medium text-regular text-grey-700">
          Currently you can only register for this class with a "waitlist"
          status. If a spot opens up, you will be automatically added and a
          confirmation email will be sent to you.
        </div>
      </div>
    </ConfirmationPopup>
  );
};

export default WaitlistConfirmationPopup;
